import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { ChevronLeft } from 'lucide-react'

import { SearchPanel } from '@/components/knowledge-base/search-panel'
import { Button } from '@/components/ui/button'

export const Route = createFileRoute('/_authenticated/knowledge-base/search')({
  component: SearchPage,
})

/**
 * 知识库搜索页面
 * 全文搜索界面
 */
function SearchPage() {
  const navigate = useNavigate()

  const handleBack = () => {
    void navigate({ to: '/knowledge-base' })
  }

  const handleSelectResult = (documentId: string) => {
    void navigate({ to: '/knowledge-base/documents/$documentId', params: { documentId } })
  }

  return (
    <div className="flex h-full flex-col">
      {/* Header */}
      <div className="border-b px-6 py-4">
        <div className="flex items-center gap-4">
          <Button variant="ghost" size="icon" onClick={handleBack}>
            <ChevronLeft className="h-5 w-5" />
          </Button>
          <div>
            <h1 className="text-xl font-bold">搜索知识库</h1>
            <p className="text-sm text-muted-foreground">搜索所有文档内容</p>
          </div>
        </div>
      </div>

      {/* Search Panel */}
      <div className="flex-1 overflow-hidden">
        <SearchPanel onSelectResult={handleSelectResult} />
      </div>
    </div>
  )
}
